module.exports = __webpack_public_path__ + "img/4B.a80ed9eb.jpg";